/**
 * BottomNav — fixed bottom tab bar shown ONLY post-login on PersonalDashboard.
 *
 * Phase 19 redesign:
 *   • Profiles tab removed (profile selection now lives in the pre-login Lobby).
 *   • Three core tabs: HOME · LEADERBOARD · PROOF WALL.
 *   • Mobile-only (md:hidden) — desktop keeps the rich multi-column dashboard.
 *
 * Tactical Brutalism preserved: sharp corners, font-mono uppercase, neon-blue
 * underline on the active tab, edge-to-edge with safe-area bottom padding.
 */
import { Home, Trophy, Camera } from "lucide-react";

const TABS = [
  { key: "home",        label: "HOME",        Icon: Home },
  { key: "leaderboard", label: "LEADERBOARD", Icon: Trophy },
  { key: "feed",        label: "PROOF WALL",  Icon: Camera },
];

export default function BottomNav({ active = "home", onChange }) {
  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 backdrop-blur-2xl bg-black/85 border-t border-white/15 safe-bottom"
      data-testid="bottom-nav"
      role="tablist"
      aria-label="Primary navigation"
    >
      <div className="grid grid-cols-3 max-w-[600px] mx-auto">
        {TABS.map(({ key, label, Icon }) => {
          const isActive = active === key;
          return (
            <button
              key={key}
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange?.(key)}
              className={`relative flex flex-col items-center justify-center gap-1 py-3 hover-flip ${
                isActive ? "text-white" : "text-[var(--stakes-muted)] hover:text-white"
              }`}
              data-testid={`bottom-nav-${key}`}
              style={{ minHeight: 64 }}
            >
              <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
              <span className="label-mono text-[10px]" style={{ letterSpacing: "0.15em" }}>{label}</span>
              {isActive && (
                <span
                  className="absolute bottom-0 left-3 right-3 h-[3px]"
                  style={{ background: "var(--neon-blue)" }}
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
